import { useMemo, useState } from 'react';
import { safeParseConfig } from '../blockConfig';

const DEFAULT = { template: '', blanks: [] };
const BLANK_MARKER = '___';
// Deliberately plain <textarea>/<input> throughout this editor, NOT
// RichTextEditor, unlike most other block types - two real conflicts:
// `template` is split on the literal "___" marker above, and the rich-text
// marker syntax's underline is "__" (two underscores) - a decorated phrase
// sitting next to a blank could corrupt the split or get misparsed as an
// underline run. `blanks[].accepted` is compared for exact string equality
// against the student's typed answer on the platform side - a decorated
// accepted answer would never match a student's plain typed text.

function countBlanks(template) {
   if(!template) return 0;
   return template.split(BLANK_MARKER).length - 1;
}

export default function FillBlankEditor({ block, onSave, onCancel }) {
   const initial = safeParseConfig(block.config, DEFAULT);
   const [template, setTemplate] = useState(initial.template || '');
   const [blanks, setBlanks] = useState(initial.blanks && initial.blanks.length ? initial.blanks : []);

   const blankCount = useMemo(() => countBlanks(template), [template]);

   const updateBlankAccepted = (i, value) => {
      const accepted = value.split(',').map(s => s.trim()).filter(Boolean);
      setBlanks(prev => {
         const next = [...prev];
         next[i] = { accepted };
         return next;
      });
   };

   const handleSave = () => {
      // resize to match however many ___ the template currently has
      const finalBlanks = Array.from({ length: blankCount }, (_, i) => blanks[i] || { accepted: [] });
      onSave({ text: template, config: JSON.stringify({ template, blanks: finalBlanks }) });
   };

   return (
      <div className='exercise-block-fill-blank-editor'>
         <textarea className='exercise-block-generic-text' rows={2} value={template}
            placeholder={'Речення з пропусками, напр: I ' + BLANK_MARKER + ' to school'}
            onChange={e => setTemplate(e.target.value)} />
         <p className='exercise-block-hint-text'>Використовуй {BLANK_MARKER} як пропуск. Знайдено пропусків: {blankCount}</p>
         {Array.from({ length: blankCount }).map((_, i) => (
            <div className='exercise-block-list-item-row' key={i}>
               <span className='exercise-block-order-index'>#{i + 1}</span>
               <input className='exercise-block-generic-text' placeholder='Правильні відповіді через кому (go, goes)'
                  value={blanks[i] && blanks[i].accepted ? blanks[i].accepted.join(', ') : ''}
                  onChange={e => updateBlankAccepted(i, e.target.value)} />
            </div>
         ))}
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderFillBlankPreview(block) {
   const cfg = safeParseConfig(block.config, DEFAULT);
   if(!cfg.template) return <span className='exercise-block-empty-hint'>Порожньо</span>;
   const parts = cfg.template.split(BLANK_MARKER);
   return (
      <p className='exercise-block-fill-blank-preview'>
         {parts.map((part, i) => (
            <span key={i}>
               {part}
               {i < parts.length - 1 ? <span className='exercise-block-blank-marker'>____</span> : ''}
            </span>
         ))}
      </p>
   );
}
